<template>
  <div class="pos-schedule-container overflow-y pt-5">
    <div class="posUserCollection-title">
      <h3>Transactionssss</h3>
    </div>
    <button @click="closeModalSection()" class="btn-modal-close">
      &times;
    </button>
    <div class="row w-100">
      <!-- FROM DATE -->
      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="transaction_date"
                @click="transaction_date = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                :disabled-dates="disabledDates"
                ref="programaticOpen"
                v-model="transaction_date"
                name="trans_date"
                id="trans_date"
                :typeable="true"
                @input="onChangeDate()"
                v-b-tooltip.hover
                :title="`Date of Transaction`"
              ></Datepicker>
              <label :class="transaction_date ? 'active' : ''"
                >Transaction Date</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4 align-self-center mb-4">
        <div class="br-10">
          <div>
            <b-form-input
              @input="onSearch"
              id="searchPosUserTrn"
              type="search"
              class="br-10"
              v-model="searchValue"
              placeholder="Search..."
              ref="searchinputele"
            ></b-form-input>
            <VkeyboardFloat
              :ID="'searchPosUserTrn'"
              :onClickFun="
                () => {
                  showVKeyboard = !showVKeyboard;
                }
              "
            />
            <Vkeyboard
              :inputName="'searchPosUserTrn'"
              :showOrHide="showVKeyboard"
              :initialValue="searchValue"
              @onChangeEvent="() => {}"
              @onKeyEnter="onSearch"
              @changeKeyboardInput="searchValue = $event"
              @onClickClose="
                () => {
                  showVKeyboard = false;
                }
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="userInfo mb-4" v-if="transactions.length > 0">
      <div>User: {{ transactions[0].booking_user_name || userInfo }}</div>
    </div>
    <div class="pos-user-collection-wrapper">
      <table
        class="swc-report-table pos-user-transaction-table mb-3"
        border="1"
      >
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Customer Phone</th>
            <th>Transaction Date & Time</th>
            <th>Show Booking Code</th>
            <th>Screen Name</th>
            <th>Film Name</th>
            <th>Show Date & Time</th>
            <th>Seats</th>
            <th>Amount</th>
            <th>Offer/Voucher</th>
            <th>Refunded Seats</th>
            <th>Refunded Amount</th>
            <th>Total Amount</th>
            <th>Print</th>
          </tr>
        </thead>
        <tbody
          v-for="(user, userIndex) in transactions"
          :key="userIndex"
          class="sph-report"
        >
          <tr>
            <td>{{ user.customer_name | filterNullUndefined }}</td>
            <td>{{ user.customer_mobile | filterNullUndefined }}</td>
            <td>{{ user.t_booking_date_time | fulldatemonparse }}</td>
            <td>{{ user.sb_booking_code }}</td>
            <td>{{ user.screen_name }}</td>
            <td>{{ user.film_name }}</td>
            <td>
              {{ user.ss_start_date | dateparse }}
              {{ user.ss_start_show_time }}
            </td>
            <td>{{ user.seats }}</td>

            <td>{{ currFormat(user.sb_total_amount) }}</td>
            <td>
              {{
                user.offer_price
                  ? "-" + currFormat(user.offer_price)
                  : currFormat(user.offer_price)
              }}
            </td>
            <td>{{ user.refunded_seats }}</td>
            <td>{{ currFormat(user.refunded_amount) }}</td>
            <td>{{ currFormat(user.final_total_amount) }}</td>

            <td>
              <b-button
                variant="default"
                @click="onPrintHandler(user.sb_id, user.sb_booking_code)"
                class="btn-blue v-step-1"
                >{{ $t("Print") }}</b-button
              >
            </td>
          </tr>
        </tbody>
        <tbody v-if="transactions.length == 0">
          <tr>
            <td colspan="13">
              <h3 v-if="transactions.length == 0" class="ml-3 text-center">
                {{ "No records found" }}
              </h3>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
      class="my-3"
    ></b-pagination>
    <ManagerAuthLogin
      :moduleName="'pos_transaction'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_pos_transaction'"
    />
    <ManagerAuthLogin
      :moduleName="'pos_transaction'"
      :onCheckAuth="onCheckAuthenticationLogin"
      :refId="'authManager_pos_transaction_login'"
    />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import PosService from "@/services/PosService.js";
import MasterService from "@/services/MasterService.js";
import _ from "lodash";
import Printd from "printd";
import { createQueryString } from "@/services/ApiHelper";
import { BASEURL } from "@/config/index";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import { Role, CLIENT_NAME } from "@/helper/Role";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";

export default {
  props: {
    childComponents: {
      type: Object,
    },
    onClickHandler: { type: Function },
  },
  components: {
    DatePicker,
    VkeyboardFloat,
    Vkeyboard,
    ManagerAuthLogin,
  },
  data() {
    return {
      pageShow: false,
      noAuthLogin: false,
      noAuth: true,
      sbId: null,
      showVKeyboard: false,
      LoggedUserId: null,
      dateDisable: false,
      transactions: [],
      transaction_date: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      EjsData: null,
      selectedvalue: "10",
      viewingnumbers: [],
      searchValue: "",
      sb_booking_code: null,
      bookingDetails: {},
      disabledDates: {
        from: new Date(Date.now() + 8640000),
      },
      TemplateList: [],
    };
  },
  computed: {
    MANAGER_AUTH_FOR_REPRINT() {
      return this.$store.getters.MANAGER_AUTH_FOR_REPRINT;
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
    },
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").first_name &&
        this.secureStore.get("USINFO").last_name
        ? this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name
        : "Admin";
    },
  },
  beforeMount() {
    const { user_id, cinema_id } = this.secureStore.get("USINFO");
    this.LoggedUserId = user_id;
    this.transaction_date = moment().format("YYYY-MM-DD");
    this.getCinemaTicketTemplate(this.secureStore.get("USINFO").cinema_id);
    this.getPosUserTransactionData();
  },
  mounted() {},
  methods: {
    onChangeDate: _.debounce(function() {
      this.getPosUserTransactionData();
    }, 1.5 * 1000),
    onSearch: _.debounce(function() {
      this.getPosUserTransactionData();
    }, 1.5 * 1000),
    onKeyPress(button) {
      if (button == "{enter}") {
        this.getPosUserTransactionData();
      }
    },
    getCinemaTicketTemplate: function(cinema_id) {
      let body = {
        cine_id: cinema_id,
      };
      MasterService.TicketTemplateByCinemaID(body).then((response) => {
        const { data } = response;
        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;
          }
        }
      });
    },
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getPosUserTransactionData();
      } else {
        this.currentPage = event;
        this.getPosUserTransactionData();
      }
    },
    onChangeSearch(input) {
      this.searchValue = input;
      this.onSearch();
    },
    getPosUserTransactionData() {
      this.transactions = [];
      let payload = {
        transaction_date: this.transaction_date
          ? moment(this.transaction_date).format("YYYY-MM-DD")
          : "",
        user_id: this.LoggedUserId,
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: this.secureStore.get("USINFO").cinema_id,
        searchValue: this.searchValue,
      };
      if (!this.transaction_date) {
        return this.$toasted.show("Please Select Transaction Date");
      } else {
        let loader = this.$loading.show();
        PosService.getPosUserTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.transactions = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = this.perPage;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else if (data.Records && data.Records.length == 0) {
              this.$toasted.show("No Records Found.");
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    closeModalSection: function() {
      this.onClickHandler("posUserTransaction");
    },
    onCheckAuthenticationLogin(response) {
      const { valid } = response;
      if (valid) {
        this.noAuthLogin = true;
        this.$bvModal.hide("authManager_pos_transaction_login");
      }
    },
    onCheckAuthentication(response) {
      const { valid, name } = response;
      if (valid) {
        if (name == "pos_transaction") {
          this.$bvModal.hide("authManager_pos_transaction");
          this.onPrintHandler(this.sbId, this.sb_booking_code);
        }
      }
    },
    onPrintHandler: function(sb_id, sb_booking_code = null) {
      if (this.MANAGER_AUTH_FOR_REPRINT == "Y" && !this.noAuth) {
        this.sbId = sb_id;
        this.sb_booking_code = sb_booking_code;
        PosService.PosBookingDetails({ bookingCode: this.sb_booking_code })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.bookingDetails = { ...data.Records[0] };
            }
          })
          .catch((error) => {
            console.log(error);
          });
        this.$bvModal.show("authManager_pos_transaction");
      } else {
        const { cinema_id } = this.secureStore.get("USINFO");
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              this.bookingDetails.sb_id = sb_id;
              this.sb_booking_code = sb_booking_code;
              // console.log({ sb_booking_code });
              if (this.sb_booking_code) {
                let addOnsArr = this.bookingDetails.final_addon_gross_charges
                  ? this.bookingDetails.final_addon_gross_charges.filter(
                      (add_on) => {
                        return add_on.is_additional_price_on_ticket === "N";
                      }
                    )
                  : [];
                // console.log(
                //   this.bookingDetails,
                //   this.bookingDetails.translation_data,
                //   "transaldata"
                // );
                let arabic_company_name = this.bookingDetails.translation_data
                  ? JSON.parse(this.bookingDetails.translation_data).filter(
                      (lang) => {
                        return lang.langaugeId == 3;
                      }
                    )[0].company_name
                  : "";
                // console.log("data", this.$store.getters);
                // console.log("showBookingId", this.bookingDetails.sb_id);
                if (String(this.TemplateList[0].t_name) != "Template-12") {
                  // console.log(this.TemplateList[0].template_id, "templateId");
                  this.$socket.emit("on_print_ticket", {
                    showBookingId: this.bookingDetails.sb_id,
                    cinema_id,
                    baseurl: BASEURL,
                    isReprint: this.isReprint,
                  });
                  let overallPrice = 0;
                  if (this.TemplateList[0].template_id == 28) {
                    console.log(
                      this.TemplateList[0].template_id,
                      "templateId21345"
                    );
                    // setTimeout(z => {
                    // if (addOnsArr.length > 0) {
                    addOnsArr.map((z, index) => {
                      overallPrice += z.final_price;
                      setTimeout(() => {
                        this.$socket.emit("on_print_ticket", {
                          addOns: JSON.stringify(z),
                          bookingDetails: JSON.stringify({
                            template_id: this.TemplateList[0].template_id,
                            pos_user_name: this.bookingDetails.pos_user_name,
                            translationData: arabic_company_name,
                            cine_name: this.bookingDetails.cine_name,
                            cine_address: this.bookingDetails.cine_address,
                            company_name: this.bookingDetails.company_name,
                            vat_number: this.bookingDetails.vat_number,
                            sb_id: this.bookingDetails.sb_id,
                            sb_booking_code: this.bookingDetails
                              .sb_booking_code,
                            og_show_date: this.bookingDetails.og_show_date,
                            og_show_time: this.bookingDetails.og_show_time,
                            sb_booking_date: this.bookingDetails
                              .sb_booking_date_time,
                            sb_booking_time: this.bookingDetails
                              .sb_booking_date_time,
                          }),
                          ttype: "addon-ticket",
                          isReprint: this.isReprint,
                          baseurl: BASEURL,
                        });
                      }, 5000);
                      // index * setTimeoutvalue);
                    });
                    // console.log("AJitttttt");
                    // }

                    setTimeout(() => {
                      this.$socket.emit("on_print_ticket", {
                        showBookingId: this.bookingDetails.sb_id,
                        cinema_id,
                        overallPrice,
                        baseurl: BASEURL,
                        ttype: "security-ticket",
                        addOnsArr: JSON.stringify(addOnsArr),
                        isReprint: this.isReprint,
                      });
                    }, 6000);
                  }
                  // setTimeout(() => {
                  //   this.$socket.emit("on_print_ticket", {
                  //     b_code: this.bookingDetails.sb_booking_code,
                  //     cinema_id: this.cinemaIdEmpire,
                  //     baseurl: BASEURL,
                  //     ttype: "security-ticket-empire",
                  //     addOnsArr: JSON.stringify(addOnsArr),
                  //     isReprint: "N"
                  //   });
                  // }, 2500);
                }
              } else {
                this.$socket.emit("on_print_ticket", {
                  showBookingId: this.bookingDetails.sb_id,
                  cinema_id,
                  baseurl: BASEURL,
                  isReprint: this.isReprint,
                });
              }

              if (true) {
                console.log("test_electron1");
              }
            }
          } catch (err) {
            console.log("Error:", err);
          }
        } else {
          let isReprint = true;
          PosService.GetTicketEjs(sb_id, cinema_id, isReprint)
            .then(async (response) => {
              const { data } = response;

              this.EjsData = data;

              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, []);
                }
              });
            })
            .catch((err) => {
              console.log("Error:", err);
            });
          PosService.GetTicketSecurityEjs(sb_id, cinema_id, isReprint)
            .then(async (response) => {
              const { data } = response;

              this.EjsData = data;

              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, []);
                }
              });
            })
            .catch((err) => {
              console.log("Error:", err);
            });
        }
      }
    },
  },
};
</script>

<style>
#line-progress {
  border-radius: 7px;
}
.pos-user-collection strong {
  /* line-height: 55px; */
}
.posUserCollection-title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 42px;
}
.no-data {
  text-align: center;
  font-size: 17px;
  margin-top: 130px;
}
.userInfo {
  font-weight: 500;
  font-size: 22px;
}
.pos-user-collection-wrapper {
  /* font-size: 20px; */
  max-width: 100%;
  overflow: scroll;
}
.pos-user-transaction-table {
  table-layout: auto !important;
  white-space: nowrap;
  border: none;
}

.pos-user-transaction-table thead tr {
  background: #96969640;
}

.pos-user-transaction-table th,
.pos-user-transaction-table td {
  padding: 15px !important;
}
.virtual-keyboard {
  width: 80%;
  height: auto;
  margin: auto;
}
.br-10 {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posUserTransaction.vue